module.exports = __webpack_public_path__ + "img/view.1bdff778.png";